
        import * as module0 from '$components/shared/lastfm.js'
        const modules = {
            "shared/lastfm.js": module0,
        };
        export default modules;
      